"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPlayerBetHistoryToSerializable = void 0;
const convertPlayerBetHistoryToSerializable = ({ totalGames, totalGamesWon, totalGamesRefund, totalSpend, totalWinnings, totalRefunds, rounds, gameState, owner }) => {
    return {
        totalGames,
        totalGamesWon,
        totalGamesRefund,
        totalSpend: totalSpend.toString(),
        totalWinnings: totalWinnings.toString(),
        totalRefunds: totalRefunds.toString(),
        rounds,
        gameState: gameState.toBase58(),
        owner: owner.toBase58()
    };
};
exports.convertPlayerBetHistoryToSerializable = convertPlayerBetHistoryToSerializable;
